import {NgxLoggerLevel} from 'ngx-logger';

export const environment = {
  production: false,

  apiHost: 'https://api.sandbox.companybox.com',
  builderUrl: "https://storage.googleapis.com/companybox-sandbox-cdn/builder",
  isBuilderProduction: false,

  config: {
    name: 'cb',
    title: 'CompanyBox: Custom Boxes & Packaging Made Easy',
    logo: 'assets/cb/images/CompanyBox_rgb.png',
    marketingSite: 'https://www.companybox.com',
  },

  features: {
    aiImageGeneration: true,
    rewards: false,
    hubspotChat: false,
  },

  orderPrefix: 'ST',

  logger: {
    logLevel: NgxLoggerLevel.TRACE,
    serverLogLevel: NgxLoggerLevel.OFF,
    serverLoggingUrl: undefined
  },

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
